module.exports = __webpack_public_path__ + "media/src/images/partners/foggia-5781272a2bc3a81b05459936f21827be.jpg";